import React from 'react'
import { urlKey } from '../../../services/api/api-urls'
import { getColModelItem } from '../../../services/lib/utils/helpers'


export const colKey: any = {
  baseProductName: 'baseProductName',
  productCode: 'productCode',
  description: 'description',
  rawMaterialDesc: 'rawmaterialDesc',
  grossWeigh:'grossWeigh',
  cartonLength: 'cartonLength',
  cartonWidth: 'cartonWidth',
  cartonHeight: 'cartonHeight',
  // visible: 'visible',
  imgUrl: 'imgUrl',
  productType: urlKey.ProductType,
  rawMaterial: urlKey.RawMaterial,
  packagingTypeId: urlKey.PackagingType,
}

const keyInfosArray: any = () => {
  return [
    {key: colKey.baseProductName, label: '', otherOptions: {type: 'inputTextArea',width: '20rem',required: true}},
    {key: colKey.productCode, label: 'Code', otherOptions: {required: true}},
    // {key: colKey.productType, label: 'Type', otherOptions: {type: 'select',required: true}},
    {key: colKey.rawMaterial, label: 'Raw 1', otherOptions: {type: 'select', isOverrideSelectionOptions: true, valueJoinArray: ['rawMaterialName', 'rawMaterialCode']}},
    {key: colKey.packagingTypeId, label: 'Pack Type', otherOptions: {type: 'packagingTypeCascadeSelect', rowDataKeyword: 'packagingTypeId', required: false}},
    {key: colKey.description, label: 'Base Product Note', otherOptions: {type: 'inputTextArea'}},
    {key: colKey.rawMaterialDesc, label: 'Quote Specs', otherOptions: {type: 'inputTextArea'}},
    // {key: colKey.visible, label: 'visible', otherOptions: {type: 'select'}},
    {key: colKey.imgUrl, label: 'Sample', otherOptions: {type: 'image'}},
    {key: colKey.cartonLength, label: 'CTN L (mm)', otherOptions: {rowDataKeyword: 'baseProduct.cartonLength'}},
    {key: colKey.cartonWidth, label: 'CTN W (mm)', otherOptions: {rowDataKeyword: 'baseProduct.cartonWidth'}},
    {key: colKey.cartonHeight, label: 'CTN H (mm)', otherOptions: {rowDataKeyword: 'baseProduct.cartonHeight'}},
    {key: colKey.grossWeigh, label: 'G.W. (kg)', otherOptions: {rowDataKeyword: 'baseProduct.grossWeigh'}},
  ]
}

const colInfos: any = {
  baseProduct: {
    title: 'Base Product Name',
    field: 'baseProduct',
    keywords: [colKey.baseProductName]
	 },
  productCode: {
    title: 'Base Product Info',
    field: 'productCode',
    keywords: [colKey.productCode, colKey.packagingTypeId]
  },
  rawMaterial: {
    title: 'Other Info',
    field: 'rawMaterial',
    keywords: [colKey.description, colKey.rawMaterialDesc, colKey.rawMaterial],
  },
  package: {
    title: 'Pkg Info',
    field: 'package',
    keywords: [colKey.cartonLength, colKey.cartonWidth, colKey.cartonHeight, colKey.grossWeigh],
  },  
  imgUrl: {
    title: 'Sample',
    field: 'imgUrl',
    keywords: [
      colKey.imgUrl
    ]
  },  
}

export const myfiler=(
  filterValue:any,
  rowData:any
) => {
  console.log(rowData)
  const filter = filterValue.replace(/-/g, '\u2011').trim();
  const prodCode = (rowData.productCode?.replace(/-/g, '\u2011')?.trim())?.toUpperCase();

  if (prodCode?.indexOf(filter.toUpperCase()) >=0) return true;
  const prodName = (rowData.baseProductName?.replace(/-/g, '\u2011')?.trim())?.toUpperCase();
  // console.log(prodName)
  if (prodName?.indexOf(filter.toUpperCase()) >=0) return true;
  // if (rowData.productType?.productTypeName?.toUpperCase().indexOf(filter.toUpperCase()) >=0) return true;
  if (rowData.rawMaterial?.rawMaterialName?.toUpperCase().indexOf(filter.toUpperCase()) >=0) return true;
  if (rowData.rawMaterial2?.rawMaterialName?.toUpperCase().indexOf(filter.toUpperCase()) >=0) return true;
  return false;
} 

const isCellEditable = (cellData:any,rowData: any) => {
  if (!rowData) return true;
  if (rowData.manufactured === 1) {
    return false;
  }
  return true;
};

const BaseProductManagementColumnModel = () => {
  return [
    {
      ...getColModelItem(colInfos.baseProduct, keyInfosArray),
      render: (rowData:any) => rowData.baseProductName,
      editable: isCellEditable,
      width: 300, // Base Product Name列宽度
      customFilterAndSearch:(        filterValue:any,
        rowData:any) =>myfiler(
        filterValue,
        rowData
      )
    },
    {
      ...getColModelItem(colInfos.productCode, keyInfosArray),
      editable: isCellEditable,
      width: 350, // Base Product Info列宽度，显示多行信息
      render: (rowData: any) => {
        try {
          const parts: string[] = []

          // Add product code
          if (rowData.productCode) {
            parts.push(`Code: ${rowData.productCode}`)
          }

          // Add product type (仅在非编辑模式下显示)
          // if (rowData.productType?.productTypeName) {
          //   parts.push(`Type: ${rowData.productType.productTypeName}`)
          // }

          // Add packaging type with proper formatting
          if (rowData.packagingType && typeof rowData.packagingType === 'object' && rowData.packagingType.quantity) {
            const pt = rowData.packagingType
            const qty = Number(pt.quantity)
            const sleeve = Number(pt.sleevePkt)
            if (!isNaN(qty) && !isNaN(sleeve) && qty > 0 && sleeve > 0) {
              const sleeveQty = qty / sleeve
              const category = pt.packagingCategory || 'Carton'
              parts.push(`Pack: ${qty} / ${category} / ${sleeve} * ${sleeveQty}`)
            }
          }

          // 使用明确的换行符，并添加额外的样式支持换行
          return (
            <div style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
              {parts.join('\n')}
            </div>
          )
        } catch (error) {
          console.error('Error rendering product code:', error)
          return String(rowData.productCode || '')
        }
      },
      customFilterAndSearch:(        filterValue:any,
        rowData:any) =>myfiler(
        filterValue,
        rowData
      )
    },

    {
      ...getColModelItem({
        title: 'Raw 2',
        field: 'rawMaterialId2',
        keywords: [
          urlKey.RawMaterial,
        ]
      }, () => ([{key: urlKey.RawMaterial, label: 'Raw 2', otherOptions: {type: 'select', rowDataKeyword: 'rawMaterialId2'}}])),
      editable: isCellEditable,
      width: 280, // Raw 2列宽度，显示原材料名称和代码
      render: (rowData:any) => rowData.rawMaterial2 ? `${rowData.rawMaterial2?.rawMaterialName}(Code: ${rowData.rawMaterial2?.rawMaterialCode})` : null,
    },
    {
      ...getColModelItem(colInfos.rawMaterial, keyInfosArray),
      editable: isCellEditable,
      width: 300, // Other Info列宽度，合并了Customer Visible信息
      render: (rowData: any) => {
        const parts: string[] = []

        // 添加原有的原材料信息
        if (rowData.rawMaterial?.rawMaterialName) {
          parts.push(`Raw 1: ${rowData.rawMaterial.rawMaterialName}`)
        }

        // 添加描述信息
        if (rowData.description) {
          parts.push(`Note: ${rowData.description}`)
        }

        // 添加Customer Visible状态
        const isVisible = rowData.visible === 1
        parts.push(`Cust Visible: ${isVisible ? 'Yes' : 'No'}`)

        return (
          <div style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', fontSize: '13px' }}>
            {parts.join('\n')}
          </div>
        )
      },
    },
    {
      title: 'Outs.',
      field: 'manufactured',
      initialEditValue: 0,
      width: 60, // Out Src列宽度，较窄的状态列
      // editable: 'onAdd',
      editable: 'never',
      type: 'numeric',
      lookup: {0: 'No', 1: 'Yes'}
    },
    {
      ...getColModelItem(colInfos.package, keyInfosArray),
      editable: isCellEditable,
      width: 350, // Package Information列宽度，显示详细包装规格
    },
  ]
}

export default BaseProductManagementColumnModel